<template>
  <div v-show="editShow">
    <div class="container">
      <div class="form-box">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="120px"
          class="eidt-el-form el-form-wrap"
        >
          <el-form-item label="上传图片">
            <UploadImg
              @uploadImg="getUploadImg1"
              :editImg="editImg1"
            ></UploadImg>
            <el-input
              v-model="ruleForm.img"
              clearable
              placeholder="url"
              class="el-input-position"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="clearfix">
        <div class="crumbs">
          <i class="el-icon-back"></i>
          <el-button type="text" @click="goBack">返回</el-button>
        </div>
      </div>
      <el-row :gutter="20">
        <el-form
          ref="tableData"
          :model="list"
          :rules="rules1"
          class="demo-ruleForm"
        >
          <el-button
            style="float: right; margin-left: 10px"
            type="primary"
            @click="save"
            >保存</el-button
          >
          <el-button
            style="float: right; margin-left: 10px"
            type="primary"
            plain
            @click="addRow"
            >新增</el-button
          >
          <el-table
            :data="list.tableData"
            style="width: 100%; margin-bottom: 30px; z-index: 1"
          >
            <el-table-column width="100" label="排序">
              <template slot-scope="scope" prop="indexNo">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.indexNo'"
                  :rules="rules1.indexNo"
                >
                  <el-input
                    v-model="scope.row.indexNo"
                    style="width: 65px"
                    type="number"
                    min="1"
                    minlength="1"
                    maxlength="2"
                    @change="indexChange()"
                    max="99"
                    class="el-input"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="150">
              <template slot-scope="scope" prop="rule">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.type'"
                  :rules="rules1.type"
                >
                  <el-select
                    placeholder="类型："
                    clearable
                    v-model="scope.row.type"
                    class="el-input-position"
                  >
                    <el-option
                      v-for="(item, index) in types"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="启用" width="150">
              <template slot-scope="scope" prop="enabled">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.enabled'"
                  :rules="rules1.enabled"
                >
                  <el-radio-group v-model="scope.row.required">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="名称" width="150">
              <template slot-scope="scope" prop="name">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.name'"
                  :rules="rules1.name"
                >
                  <el-input
                    v-model="scope.row.name"
                    clearable
                    placeholder="名称"
                    class="el-input-position"
                  ></el-input>
                  <el-input
                    v-if="scope.row.type == 8"
                    v-model="scope.row.value"
                    clearable
                    placeholder="展位"
                    class="el-input-position"
                  ></el-input>
                  <el-input
                    v-if="scope.row.type == 8 "
                    v-model="scope.row.input"
                    clearable
                    type="text"
                    placeholder="展品描述"
                    class="el-input-position"
                  ></el-input>
                  <!-- <el-input
                    v-if="scope.row.type == 8 "
                    v-model="scope.row.propertyId"
                    clearable
                    placeholder="收藏数量"
                    type="number"
                    class="el-input-position"
                  ></el-input> -->
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="分组" width="200">
              <template slot-scope="scope" prop="options">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.options'"
                  :rules="rules1.options"
                >
                  <el-input
                    placeholder="分组"
                    v-model="scope.row.options"
                    clearable
                    class="el-input-position"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="跳转地址" width="200">
              <template slot-scope="scope" prop="options">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.url'"
                  :rules="rules1.url"
                >
                  <el-input
                    placeholder="跳转地址"
                    v-model="scope.row.url"
                    clearable
                    class="el-input-position"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="200">
              <template slot-scope="scope" prop="img">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.img'"
                  :rules="rules1.img"
                >
                  <el-input
                    placeholder="图片"
                    v-model="scope.row.img"
                    clearable
                    class="el-input-position"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="80" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  plain
                  @click="deleterow(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
            <el-table-column width="10"></el-table-column>
          </el-table>
        </el-form>
      </el-row>
    </div>
  </div>
</template>
<script>
function sortBy(props) {
  return function (a, b) {
    return a[props] - b[props];
  };
}
function filterOne(dataList, value, type) {
  var s = dataList.filter(function (item, index, arr) {
    for (let j = 0; j < type.length; j++) {
      if (item[type[j]] != undefined || item[type[j]] != null) {
        if (item[type[j]].indexOf(value) >= 0) {
          return item;
        }
      }
    }
  });
  return s;
}

var types = [
  { name: "首页轮播图", value: 0 },
  { name: "1张大图按钮", value: 1 },
  { name: "2组图片按钮", value: 2 },
  { name: "3组图片按钮", value: 3 },
  { name: "4组图片按钮", value: 4 },
  { name: "5组图片按钮", value: 5 },
  { name: "图文板块", value: 6 },
  { name: "推荐展品", value: 7 },
  { name: "推荐展商", value: 8 },
  { name: "其他", value: 9 },
];

import UploadImg from "../public/UploadImg";

export default {
  name: "editvihicel",
  data() {
    return {
      rules1: {
        required: [{ required: false, message: "启用禁用", trigger: "blur" }],
        type: [{ required: false, message: "类型不能为空", trigger: "blur" }],
        name: [{ required: false, message: "名称不能为空", trigger: "blur" }],
        indexNo: [{ required: true, message: "排序不能为空", trigger: "blur" }],
      },
      types: types,
      projectId: localStorage.getItem("project_Id"),
      editImg: "",
      editImg1: "",
      imgTitle: "上传图片",
      ruleForm: {
        img: "",
      },
      list: {
        tableData: [
          {
            indexNo: 1,
            name: "",
            img: "",
            options: "",
            value: "",
            required: 1,
            type: "1",
            url: "",
            input: "",
            propertyId: null,
          },
        ],
      },
    };
  },
  created() {},
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      this.$axios.get("/ProjectProperty/" + this.projectId).then((res) => {
        if (res.data.hasError == false && res.data.data) {
          this.list.tableData = [...res.data.data];
        }
      });
    },
  },
  methods: {
    querySearch(queryString, cb) {
      cb(filterOne(array, queryString, ["value"]));
    },
    save() {
      this.$axios
        .post("/ProjectProperty/" + this.projectId, this.list.tableData)
        .then((res) => {
          if (res.data.hasError == false) {
            this.$message.success("编辑成功！");
            this.goBack();
          } else {

            this.$message.error(res.data.message);
          }
        });
    },
    saveClick(ruleForm) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$axios
            .put("/Raffle/" + this.projectId + "", this.ruleForm)
            .then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("编辑成功！");
                this.goBack();
              } else {

                this.$message.error(res.data.message);
              }
            });
        } else {
          return false;
        }
      });
    },
    indexChange() {
      this.list.tableData.sort(sortBy("indexNo"));
    },
    addRow() {
      var list = {
        indexNo: this.list.tableData.length + 1,
        name: "",
        img: "",
        options: "",
        required: 1,
        url: "",
        value: "",
        projectId: localStorage.getItem("project_Id"),
        type: 1,
        input: "",
        propertyId: null,
      };
      this.list.tableData.push(list);
    },
    deleterow(index, row) {
      this.list.tableData.splice(index, 1);
      for (var i = 0; i < this.list.tableData.length; i++) {
        this.list.tableData[index].indexNo = i + 1;
      }
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.img = "";
      this.editImg = "";
      this.editImg1 = "";
      this.list.tableData = [];
    },
    getUploadImg1(imgSrc) {
      this.ruleForm.img = imgSrc;
    },
  },
  components: {
    UploadImg,
  },
};
</script>

<style lang="scss" scoped>
.el-form-wrap {
  width: 100% !important;
}
.line-box {
  display: flex;
  flex: 1;
}
.line-box .el-form-item,
.line-box .up-img {
  width: 40% !important;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>